export default {
    api: {
        getbaomingInfo: {
            url: '/api.php/action/baoming',
            method: 'post',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        h5baoming: {
            url: '/api.php/order/h5baoming',
            method: 'post',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        doMobileLogin: {
            url: '/api.php/user/doMobileLogin',
            method: 'post',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },

        //订单列表
        getOrderList: {
            url: '/api.php/user/getOrderList',
            method: 'get',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        //支付配置信息
        doPay: {
            url: '/api.php/pay/doPay',
            method: 'post',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        //分享
        getWechatConfig: {
            url: '/api.php/wechat/getWechatConfig',
            method: 'post',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        //订单详情
        getOrderInfoByID: {
            url: '/api.php/user/getOrderInfoByID',
            method: 'get',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        //用户点赞
        doUserToNewsLike: {
            url: '/api.php/user/doUserToNewsLike',
            method: 'post',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        //退款
        refundOrder: {
            url: '/api.php/order/refundOrder',
            method: 'post',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },


    },
    hooks: {
        beforeContactReq(callback) {
            callback && callback()
        },
        receiveContactRes(callback) {
            callback && callback()
        }
    }
}